var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cancelamento"},[_c('CardCancelar',{staticClass:"item",attrs:{"userInfo":_vm.user,"planInfo":_vm.planInfo}}),_c('FormularioCancelamento',{staticClass:"item",attrs:{"userInfo":_vm.user,"planInfo":_vm.planInfo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }